import React from "react"

export const PlusIcon = props => {
  return (
    <svg
      width="25px"
      height="25px"
      viewBox="0 0 25 25"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>Plus/Mobile</title>
      <desc>Created with Sketch.</desc>
      <g
        id="Desktop-+-Mobile"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="A21_Mobile-Contact"
          transform="translate(-328.000000, -637.000000)"
          stroke="#000000"
        >
          <g id="Artists" transform="translate(18.000000, 617.000000)">
            <g id="Plus" transform="translate(310.000000, 20.000000)">
              <g>
                <g>
                  <path
                    d="M0,12.5 L25,12.5"
                    id="Stroke-3"
                    transform="translate(12.500000, 12.500000) rotate(90.000000) translate(-12.500000, -12.500000) "
                  />
                  <path d="M0,12.5 L25,12.5" id="Stroke-5" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
